import { noop } from "../utils/noop.js";
//#region src/internalLogger/const.ts
let InternalLoggerLevel = /* @__PURE__ */ function(InternalLoggerLevel) {
	InternalLoggerLevel[InternalLoggerLevel["OFF"] = 0] = "OFF";
	InternalLoggerLevel[InternalLoggerLevel["ERROR"] = 1] = "ERROR";
	InternalLoggerLevel[InternalLoggerLevel["WARN"] = 2] = "WARN";
	InternalLoggerLevel[InternalLoggerLevel["INFO"] = 3] = "INFO";
	InternalLoggerLevel[InternalLoggerLevel["VERBOSE"] = 4] = "VERBOSE";
	return InternalLoggerLevel;
}({});
const defaultInternalLoggerPrefix = "Faro";
const defaultInternalLogger = {
	debug: noop,
	error: noop,
	info: noop,
	prefix: defaultInternalLoggerPrefix,
	warn: noop
};
const defaultInternalLoggerLevel = 1;
//#endregion
export { InternalLoggerLevel, defaultInternalLogger, defaultInternalLoggerLevel, defaultInternalLoggerPrefix };

//# sourceMappingURL=const.js.map